export enum ContainerNetworkType {
  P = "P",
  S = "S",
}
